import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import immutableState from "redux-immutable-state-invariant";
import { API } from "@thenounproject/lingo-core";

import notification from "../middleware/notification";
import analytics from "../middleware/analytics";
import polling from "../middleware/polling";
import downloadFile from "../middleware/downloadFile";
import rootReducer from "../reducers";
import sentry from "../middleware/sentry";

export default function configureStore(preloadedState = undefined) {
  let middlewares = [thunk, API.middleware, notification, downloadFile, polling, analytics];

  let composeEnhancers = compose;
  const isProd = process.env.NODE_ENV === "production";

  if (isProd) {
    // Only run Sentry in production
    middlewares.push(sentry);
  } else {
    // Only run immuntable state checking in development
    middlewares = [immutableState(), ...middlewares];
    // Only enable redux devtools in development
    if (window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]) {
      composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]({});
    }
  }

  const store = createStore(
    rootReducer,
    preloadedState,
    composeEnhancers(applyMiddleware(...middlewares))
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept("../reducers", () => {
      const nextReducer = require("../reducers").default;
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}
